













































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import { orderBy } from "lodash";
import CardModalAlasanBatalOrder from "@/components/modal/CardModalAlasanBatalOrder.vue";
import { storePenunjang } from "@/store/modules/penunjang";
import { userModule } from "@/store/modules/user";

interface OrderPenunjang {
  id: number | string;
  date: string;
  status: number | string;
  prioritas: string | null;
  clinical_note: string | null;
  alasan_batal: string | null;
  unit_pelayanan: { id: string; name: string } | null;
  dokter: { id: number | string; name: string } | null;
  items: { id: string; name: string }[] | null;
}

interface GrupOrder {
  kunci: string;
  asal: string;
  tanggal: string;
  urutan: string;
  dokter: string;
  pemeriksaan: string;
  jumlahBatal: number;
  order: OrderPenunjang[];
}

@Component({
  components: {
    CardModalAlasanBatalOrder
  }
})
export default class CardDaftarOrderRingkas extends Vue {
  @Prop({ default: () => [] }) readonly dataOrder!: OrderPenunjang[];
  @Prop() readonly type!: string;
  @Prop({ type: Boolean, default: false }) readonly readOnly!: boolean;

  panel: number | null = null;
  modalBatalOrder = false;
  idOrder = "";

  get stateuser() {
    return userModule.user;
  }

  get memuat(): boolean {
    return this.type === "lab"
      ? storePenunjang.loadingOrderLab
      : storePenunjang.loadingOrderRadiologi;
  }

  get bisaBuatOrder(): boolean {
    return this.stateuser.profesi == "Dokter" && !this.readOnly;
  }

  get daftar(): GrupOrder[] {
    const grup: Record<string, GrupOrder> = {};
    (this.dataOrder || []).forEach(order => {
      const asal =
        ((order.unit_pelayanan && order.unit_pelayanan.name) || "").trim() ||
        "-";
      const m = moment(order.date, "DD-MM-YYYY");
      const urutan = m.isValid() ? m.format("YYYY-MM-DD") : order.date || "";
      const kunci = `${asal}|${urutan}`;
      if (!grup[kunci]) {
        grup[kunci] = {
          kunci,
          asal,
          tanggal: m.isValid() ? m.format("DD MMM YYYY") : order.date || "-",
          urutan,
          dokter: "",
          pemeriksaan: "",
          jumlahBatal: 0,
          order: []
        };
      }
      grup[kunci].order.push(order);
    });

    const hasil = Object.keys(grup).map(kunci => {
      const g = grup[kunci];
      g.order = orderBy(g.order, [o => Number(o.id)], ["desc"]);
      g.dokter = this.gabungUnik(
        g.order.map(o => (o.dokter && o.dokter.name) || "")
      );
      g.pemeriksaan = this.gabungUnik(
        g.order
          .filter(o => !this.dibatalkan(o))
          .reduce(
            (semua: string[], o) =>
              semua.concat((o.items || []).map(i => i.name)),
            []
          )
      );
      g.jumlahBatal = g.order.filter(o => this.dibatalkan(o)).length;
      return g;
    });
    return orderBy(hasil, ["urutan"], ["desc"]);
  }

  statusOrder(order: OrderPenunjang): number {
    return Number(order.status);
  }

  dibatalkan(order: OrderPenunjang): boolean {
    return this.statusOrder(order) === -1;
  }

  labelStatus(order: OrderPenunjang): string {
    const status = this.statusOrder(order);
    if (status === -1) return "Dibatalkan";
    if (status === 2) return "Sudah diproses";
    return "Belum diproses";
  }

  warnaStatus(order: OrderPenunjang): string {
    const status = this.statusOrder(order);
    if (status === -1) return "red lighten-1";
    if (status === 2) return "success";
    return "blue-grey";
  }

  bisaUbah(order: OrderPenunjang): boolean {
    return (
      !this.readOnly &&
      this.stateuser.profesi == "Dokter" &&
      this.statusOrder(order) === 1 &&
      !!order.dokter &&
      order.dokter.id == this.stateuser.id
    );
  }

  namaItem(order: OrderPenunjang): string {
    return this.gabungUnik((order.items || []).map(i => i.name));
  }

  gabungUnik(nama: string[]): string {
    return nama
      .filter(n => !!n)
      .filter((n, i, semua) => semua.indexOf(n) === i)
      .join(", ");
  }

  ubahOrder(order: OrderPenunjang) {
    this.$emit("editOrder", {
      detail: order,
      page: "buat-order",
      type: this.type
    });
  }

  batalOrder(order: OrderPenunjang) {
    this.idOrder = String(order.id);
    this.modalBatalOrder = true;
  }

  alasanBatal(value) {
    this.$emit("alasanBatal", value);
  }
}
